<div class="duna-cleaning-unique-events-container">
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Rengørings-events</h1></mat-card-title>
      <mat-card-subtitle>
        Events i jeres organisation hvor «Rengøring» er markeret i aktivitetens ekstra-indstillinger.
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>

  @if (linkValidationPending && linkUuid) {
    <mat-card class="message-card message-card--state">
      <mat-card-content>
        <p class="state-message">Tjekker rengørings-link…</p>
      </mat-card-content>
    </mat-card>
  }

  @if (linkErrorMessage) {
    <mat-card class="message-card message-card--error">
      <mat-card-content>
        <p class="error-message">{{ linkErrorMessage }}</p>
      </mat-card-content>
    </mat-card>
  }

  @if (showEventTables) {
    <mat-card class="table-card">
      <mat-card-header>
        <mat-card-title>Kommende og igangværende</mat-card-title>
        <mat-card-subtitle>Events der ikke er afsluttet</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <app-dynamic-table [dynamicInput]="{ dataSource: { type: 'text', value: 'duna_cleaning_unique_future' } }">
        </app-dynamic-table>
      </mat-card-content>
    </mat-card>

    <mat-card class="table-card">
      <mat-card-header>
        <mat-card-title>Tidligere</mat-card-title>
        <mat-card-subtitle>Afsluttede events</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <app-dynamic-table [dynamicInput]="{ dataSource: { type: 'text', value: 'duna_cleaning_unique_past' } }">
        </app-dynamic-table>
      </mat-card-content>
    </mat-card>
  }
</div>
